module.exports = __webpack_public_path__ + "228b814073a54cd88edfc7203b99ff0b.pdf";